export class SituationFamilialeModel {
    estEnCouple: boolean;
    situationFamille: string;
}
